export default "__VITE_ASSET__869dcff4__"